/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitProfileExtensionEnum } from './PressKitProfileExtensionEnum';
import {
    PressKitProfileExtensionEnumFromJSON,
    PressKitProfileExtensionEnumFromJSONTyped,
    PressKitProfileExtensionEnumToJSON,
} from './PressKitProfileExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import type { PressKitThumbnailUrls } from './PressKitThumbnailUrls';
import {
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキットプロフィールの詳細
 * @export
 * @interface PressKitProfiles
 */
export interface PressKitProfiles {
    /**
     * PressKit Profile UUID(v4)
     * @type {string}
     * @memberof PressKitProfiles
     */
    id: string;
    /**
     * プロフィール画像のファイルリソースが保存されたS3のURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitProfiles
     */
    resourceUri?: string;
    /**
     * 
     * @type {PressKitProfileExtensionEnum}
     * @memberof PressKitProfiles
     */
    extension: PressKitProfileExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitProfiles
     */
    fileSize: number;
    /**
     * 企業が登録したプロフィールの役職
     * @type {string}
     * @memberof PressKitProfiles
     */
    title: string;
    /**
     * 企業が登録したプロフィールの名前
     * @type {string}
     * @memberof PressKitProfiles
     */
    name: string;
    /**
     * 企業が登録したプロフィールの名前のよみがな（発音)
     * @type {string}
     * @memberof PressKitProfiles
     */
    nameKana: string;
    /**
     * 企業が登録したプロフィール文
     * @type {string}
     * @memberof PressKitProfiles
     */
    description: string;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitProfiles
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitProfiles
     */
    downloadUrl: string;
    /**
     * ラスター画像の幅。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitProfiles
     */
    imageWidth: number;
    /**
     * ラスター画像の高さ。単位はpx。ベクター画像はnull。
     * @type {number}
     * @memberof PressKitProfiles
     */
    imageHeight: number;
    /**
     * 設定されているタグ一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitProfiles
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PressKitProfiles interface.
 */
export function instanceOfPressKitProfiles(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "nameKana" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "thumbnailUrls" in value;
    isInstance = isInstance && "downloadUrl" in value;
    isInstance = isInstance && "imageWidth" in value;
    isInstance = isInstance && "imageHeight" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PressKitProfilesFromJSON(json: any): PressKitProfiles {
    return PressKitProfilesFromJSONTyped(json, false);
}

export function PressKitProfilesFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitProfiles {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'resourceUri': !exists(json, 'resource_uri') ? undefined : json['resource_uri'],
        'extension': PressKitProfileExtensionEnumFromJSON(json['extension']),
        'fileSize': json['file_size'],
        'title': json['title'],
        'name': json['name'],
        'nameKana': json['name_kana'],
        'description': json['description'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'imageWidth': json['image_width'],
        'imageHeight': json['image_height'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitProfilesToJSON(value?: PressKitProfiles | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'resource_uri': value.resourceUri,
        'extension': PressKitProfileExtensionEnumToJSON(value.extension),
        'file_size': value.fileSize,
        'title': value.title,
        'name': value.name,
        'name_kana': value.nameKana,
        'description': value.description,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'image_width': value.imageWidth,
        'image_height': value.imageHeight,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

